module.exports = __webpack_public_path__ + "static/img/ent-89.583ca89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-89.jpg
// module id = 7i3/
// module chunks = 52